import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable, Subject} from 'rxjs';
import {DIAGRAM_VERSION_STATES_ENUM} from 'src/app/editor-interface/shared/models/diagram-version.constant';

@Injectable({
  providedIn: 'root'
})
export class MapTreeService {
  constructor(private http: HttpClient) {}

  private updateTreeSubject = new Subject();
  public updateTreeTrigger$ = this.updateTreeSubject.asObservable();

  public partialTree(targetId, targetVer): Observable<VersionTreeNode> {
    return this.http.get<VersionTreeNode>(
      `${environment.API_ENDPOINT}/diagram/${targetId}/state/${targetVer}/tree`
    );
  }

  public diagramChildren(diagramId, version): Observable<Array<VersionTreeNode>> {
    return this.http.get<Array<VersionTreeNode>>(
      `${environment.API_ENDPOINT}/diagram/${diagramId}/state/${version}/children`
    );
  }

  public triggerUpdate() {
    this.updateTreeSubject.next(true);
  }
}

export class FlatMap {
  public readonly map: Array<VersionTreeNode> = [];

  constructor(tree: VersionTreeNode) {
    this.flatten(tree, this.map);
  }

  private flatten(node: VersionTreeNode, arr: Array<VersionTreeNode>) {
    if (node) {
      arr.push(node);

      if (node.children) {
        node.children.forEach(child => this.flatten(child, arr));
      }
    }
  }

  public canMerge(newTree: VersionTreeNode): boolean {
    const root = this.map[0];

    return root.id === newTree.id && root.version === newTree.version;
  }
}

export interface VersionTreeNode {
  uuid: string;
  id: string;
  level: string;
  name: string;
  mapID: string;
  hasChildren: boolean;
  version: DIAGRAM_VERSION_STATES_ENUM;
  updatedAt: Date;
  children?: Array<VersionTreeNode>;
  childCount?: number;
  parent?: string;
}
